import { styled } from '@mui/material';
import EmailSentConfirmation from 'components/ForgotPassword/EmailSentConfirmation';
import NewPassword from 'components/ForgotPassword/NewPassword';
import PasswordResetSuccess from 'components/ForgotPassword/PasswordResetSuccess';
import ResetPasswordPage from 'components/ForgotPassword/ResetPasswordPage';
import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/ForgotPassword/PageProvider';
import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Container, Copyright, Logo, Stack } from 'shell/components';

const Desktop = () => {
    const { device } = useViewport();
    const history = useHistory();
    const {
        currentStep,
        errors,
        form,
        satisfyRequirement,
        handleSendForgotPasswordCode,
        handleResendCode,
        handleUpdatePassword,
        handleChange,
        PAGES,
    } = useContext(PageContext);

    return (
        <Container device={'desktop'} sx={{ height: '100%', pb: 3 }}>
            <CenterBox>
                <LogoWrapper alignItems={'center'}>
                    <Logo device={'desktop'} />
                </LogoWrapper>
                {currentStep === PAGES.ENTER_EMAIL && (
                    <ResetPasswordPage
                        device={device}
                        errors={errors[PAGES.ENTER_EMAIL]}
                        form={form}
                        handleChange={handleChange}
                        handleSendForgotPasswordCode={handleSendForgotPasswordCode}
                    />
                )}
                {currentStep === PAGES.EMAIL_SENT && (
                    <EmailSentConfirmation device={device} form={form} handleResendCode={handleResendCode} />
                )}
                {currentStep === PAGES.NEW_PASSWORD && (
                    <NewPassword
                        device={device}
                        errors={errors[PAGES.NEW_PASSWORD]}
                        form={form}
                        satisfyRequirement={satisfyRequirement}
                        handleChange={handleChange}
                        handleUpdatePassword={handleUpdatePassword}
                        handleResendCode={handleResendCode}
                    />
                )}
                {currentStep === PAGES.SUCCESS && (
                    <PasswordResetSuccess device={device} onLogin={() => history.push('/')} />
                )}
            </CenterBox>
            <Copyright />
        </Container>
    );
};

const CenterBox = styled(Box)(({ theme }) => {
    return {
        zIndex: 10,
        paddingTop: theme.spacing(16),
        width: 'fit-content',
        height: '100%',
    };
});

const LogoWrapper = styled(Stack)(() => {
    return {
        padding: '8px',
        '& svg': {
            width: '200px',
            height: '25px',
        },
    };
});

export default Desktop;
